<template>
  <span v-if="tooltip" v-b-tooltip.hover :title="tooltip" class="text--blurred">{{text}}</span>
  <span v-else class="text--blurred">{{text}}</span>
</template>

<script>
  import RandomWord from '@/mixins/randomWord';

  export default {
    name: 'blurred-random-word',
    props: {
      length: {
        type: [Number, String],
        default: 20
      },
      tooltip: {
        type: [String],
        default: null
      }
    },
    mixins: [RandomWord],
    computed: {
      text() {
        return this.randomWord(this.length);
      }
    }
  }

</script>
